import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u48",
  "use": "icon-u48-usage",
  "viewBox": "0 0 11 27",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 27\" id=\"icon-u48\">\n  <g transform=\"matrix(1 0 0 1 -54.5 -459.5 )\">\n    <path d=\"M 59.5 462  L 59.5 483  \" stroke-width=\"5\" stroke=\"#52c1f5\" fill=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/u48.svg
// module id = a3pR
// module chunks = 23